import semver from 'semver';

// Retourne l'état des fonctionnalités compatibles
export default function getFeatures(apiVersion) {
  if (!apiVersion) {
    return {};
  }

  // https://aexae.sharepoint.com/:x:/s/COMETE/EXWOaZUR3UBGkwzNFGP2mXoBdneb4xFBRJooyodnW2Idpw?e=vuAbfC
  return {
    // https://aexae.sharepoint.com/:w:/s/COMETE/EWVdFL8jAQdLkBGVlwikBQ8BRJa5aT5mQEePkSixTDNhIw?e=WyvYEG
    // conversations: semver.gte(apiVersion, '2.0.0'),

    // Envoi de documents par les agents
    filesUpload: semver.gte(apiVersion, '1.0.0'),

    // Pointages par les agents
    // https://aexae.sharepoint.com/:w:/s/COMETE/EZntKxOdRXJMlR2oF2Rn_ssB2bzM2tiWyQuj_CkCdpv28Q?e=McjKV9
    shiftChecks: semver.gte(apiVersion, '1.0.0'),

    // Notifications avant vacations
    // https://aexae.sharepoint.com/:w:/s/COMETE/EYjjxTwxIWdFvnIas9SGvVoBG16zV19k63GdPxRMnn9QvA?e=UFncZ0
    notifShift: semver.gte(apiVersion, '1.0.0'),

    // DPAE
    declarationNumber: semver.gte(apiVersion, '1.1.0'),

    // Application Comète On Time
    clockingsApp: semver.gte(apiVersion, '1.2.0'),

    // L'agent peut demander à modifier son contact d'urgence
    demandEmergency: semver.gte(apiVersion, '1.3.0'),
    // https://aexae.sharepoint.com/:x:/s/COMETE/EXWOaZUR3UBGkwzNFGP2mXoBdneb4xFBRJooyodnW2Idpw?e=RvTrdl
    notifMission: semver.gte(apiVersion, '1.3.0'),
    siteContacts: semver.gte(apiVersion, '1.3.0'),

    // Espace Partenaire
    partnerSpace: semver.gte(apiVersion, '1.4.0'),

    // Commentaires
    comments: semver.gte(apiVersion, '1.5.13'),

    // Pointer une pause
    canClockBreaks: semver.gte(apiVersion, '1.6.0'),

    // Pointages par badges NFC
    clockingsByNfc: semver.gte(apiVersion, '1.6.3'),
    // Pointer une départ anticipé
    canClockOutEarlier: semver.gte(apiVersion, '1.6.4'),
    // Pré-pointage
    canPreClock: semver.gte(apiVersion, '1.6.5'),
    // Paramétrage de la visualisation des pointages
    showOntimeShiftsList: semver.gte(apiVersion, '1.6.6'),
    // Notifications par SMS des anomalies de pointage
    canManageNotificationsPushAndSMS: semver.gte(apiVersion, '1.7.0'),
    // Gestion documentaire - Consultations des documents
    documentConsultations: semver.gte(apiVersion, '1.8.0'),
    // Indisponibilités horaires
    canMakeHourlyUnavailabilityDemand: semver.gte(apiVersion, '1.9.2'),
    // Formulaires MCE
    mce: semver.gte(apiVersion, '2.0.0')
  };
}
